import { orderBy } from 'lodash';
const state = () => ({
  edit_item: {},
  price: {},
  promo_product: {}
});

const getters = {
  edit_item: (state) => {
    return state.edit_item || {};
  },
  full_price: (state) => {
    return state.price || {};
  },
  breakdowns: (state, getters) => {
    return getters.full_price.breakdowns || [];
  },
  promo_product(state) {
    return state.promo_product || {};
  },
  parts(state, getters) {
    if (!getters.promo_product.parts) {
      return [];
    }
    return orderBy(
      getters.promo_product.parts.filter((x) => x.isAvailable),
      ['isAvailable', 'name'],
      ['desc', 'asc']
    );
  },
  part(state, getters) {
    return getters.parts.find((x) => x.id === getters.edit_item.partId) || {};
  },
  locations(state, getters) {
    const part = getters.parts.find((x) => x.id === getters.edit_item.partId);
    if (part) {
      return part.locations || [];
    }
    return [];
  },
  location(state, getters) {
    return getters.locations.find((x) => x.id === getters.edit_item.locationId) || {};
  },
  decorations(state, getters) {
    const location = getters.locations.find((x) => x.id === getters.edit_item.locationId);
    if (location) {
      return location.decorations || [];
    }
    return [];
  },
  decoration(state, getters) {
    return getters.decorations.find((x) => x.id === getters.edit_item.decorationId);
  },
  decoration_colors(state, getters) {
    const part = getters.decoration;
    if (!part) {
      return [];
    }
    const colors = (part.colors || [])
      .filter((x) => !x.name.includes('Custom') && !x.name.includes('Unknown'))
      .map((x) => Object.assign(x, { isFull: x.name === 'Full Color' }));
    return orderBy(colors, ['isFull', 'name'], ['desc', 'asc']);
  },
  decoration_color(state, getters) {
    return getters.decoration_colors.find((x) => x.id === getters.edit_item.decorationColorId);
  }
};

const mutations = {
  SET_EDIT_ITEM(state, item) {
    state.edit_item = item;
  },
  SET_PRICE(state, price) {
    state.price = price;
  },
  SET_LOADING_PRICE(state, val) {
    state.loading_price = val;
  },
  SET_PROMO_PRODUCTS(state, list) {
    state.promo_products = list;
  },
  SET_PROMO_PRODUCT(state, list) {
    state.promo_product = list;
  }
};

const actions = {
  setEditItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      commit(
        'SET_EDIT_ITEM',
        Object.assign(
          {
            delivery: { earliestDate: null },
            quantity: 0,
            materialId: null,
            optionIds: [],
            addressId: undefined,
            project: {},
            categoryId: null,
            coreProductId: null,
            pageOptions: [],
            pageSelections: []
          },
          item
        )
      );
      resolve();
    });
  },
  async getPrice({ commit }, req) {
    return new Promise((resolve, reject) => {
      if (!req.item || (!req.item.quantity && !req.item.campaign)) {
        commit('SET_PRICE', 0);
        resolve();
        return;
      }

      this._vm.$api
        .post(`printcart/getPrice?preview=${req.preview}`, req.item)
        .then((response) => {
          commit('SET_PRICE', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setLoadingPrice({ commit }, val) {
    return new Promise((resolve, reject) => {
      commit('SET_LOADING_PRICE', val);
      resolve();
    });
  },
  async getPromoProduct({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .get(`printcart/getPromoProduct?id=${id}`)
        .then((response) => {
          commit('SET_PROMO_PRODUCT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async getPromoPrice({ commit }, item) {
    return new Promise((resolve, reject) => {
      if (!item) {
        commit('SET_PRICE', 0);
        resolve();
        return;
      }

      this._vm.$api
        .post('printcart/getPromoPrice', item)
        .then((response) => {
          commit('SET_PRICE', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
